export default "__VITE_ASSET__25697b70__"